// src/components/PageTransition.jsx
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";

export default function PageTransition({ children }) {
  const { pathname } = useLocation();
  const prevPathnameRef = useRef(pathname);

  // Scroll to top on route change (only if pathname changed)
  useEffect(() => {
    if (prevPathnameRef.current !== pathname) {
      window.scrollTo({ top: 0, behavior: "instant" });
      prevPathnameRef.current = pathname;
    }
  }, [pathname]);

  return (
    <motion.div
      key={pathname}
      initial={false}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.15,
        ease: "easeOut",
      }}
      className="h-full"
    >
      {children}
    </motion.div>
  );
}
